import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TpcService {
    public showCookiesConsent: boolean;

    constructor() { }
}
